import {
  FormControl,
  FormHelperText,
  InputAdornment,
  Select
} from "@mui/material";
import React from "react";

const CustomDropDown = ({
  icon,
  endIcon,
  children,
  inputError,
  formControlProps = {},
  errorText,
  formStyleProps = {},
  size = "small",
  ...props
}) => {
  return (
    <FormControl
      error={inputError}
      fullWidth
      {...formControlProps}
      sx={{ ...formStyleProps }}
    
    >
      <Select
        size={size || "small"}
        startAdornment={
          icon && <InputAdornment position="start">{icon}</InputAdornment>
        }
        endAdornment={
          endIcon && <InputAdornment position="end">{endIcon}</InputAdornment>
        }
        
        {...props}
      
      >
        {children}
      </Select>
      {inputError && (
        <FormHelperText sx={{ ml: 0 }}>{errorText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomDropDown;
